import Vue from 'vue'

import Router from 'vue-router'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/home',
    component: () => import('@/views/Home.vue')
  },
  // 中科名兽医PC端首页
  {
    path: '/',
    component: () => import('@/views/index.vue')
  },
  // 聊天信息查询
  {
    path: '/chatinfo',
    component: () => import('@/views/chatinfo.vue')
  },
  // 测试
  {
    path: '/test',
    component: () => import('@/views/test.vue')
  },
  // 注册协议
  {
    path: '/announcement',
    name: 'announcement',
    component: () => import('@/views/announcement.vue')
  },
  // 隐私政策
  {
    path: '/privacypolicy',
    name: 'privacypolicy',
    component: () => import('@/views/privacypolicy.vue')
  },
  {
    path: '/sdk',
    name: 'sdk',
    component: () => import('@/views/zkjysdk.vue')
  },

  // 中科芯片隐私政策
  {
    path: '/zkxpprivacypolicy',
    component: () => import('@/views/zkxpprivacypolicy.vue')
  },
  // 直播
  {
    path: '/liveBroadcast',
    component: () => import('@/views/video/liveBroadcast.vue')
  },
  // 测试直播
  {
    path: '/liveBroadcast1',
    component: () => import('@/views/video/liveBroadcast1.vue')
  },
  // 点播
  {
    path: '/videodemand',
    component: () => import('@/views/video/videodemand.vue')
  },
  // 诊断测评方案
  {
    path: '/subject',
    name: 'Subject',
    component: () => import('@/views/subject/index.vue')
  },
  // 诊断测评方案
  {
    path: '/subjectlist',
    name: 'SubjectList',
    component: () => import('@/views/subject/subjectlist.vue')
  },
  // 牧场测评方案
  {
    path: '/pasture',
    name: 'pasture',
    component: () => import('@/views/pasture/index.vue')
  },
  // 牧场测评结果
  {
    path: '/pastureresult',
    name: 'pastureresult',
    component: () => import('@/views/pasture/pastureresult.vue')
  },
  // 实验室测评
  {
    path: '/laboratory',
    name: 'laboratory',
    component: () => import('@/views/laboratory/index.vue')
  },
  // 实验室测评结果
  {
    path: '/laboratoryresult',
    name: 'laboratoryresult',
    component: () => import('@/views/laboratory/laboratoryresult.vue')
  },
  // 伪狂犬病净化
  {
    path: '/swine',
    name: 'swine',
    component: () => import('@/views/swine/index.vue')
  },
  // 伪狂犬病净化结果
  {
    path: '/swineresult',
    name: 'swineresult',
    component: () => import('@/views/swine/swineresult.vue')
  },
  // 猪瘟净化服务
  {
    path: '/rabid',
    name: 'rabid',
    component: () => import('@/views/rabid/index.vue')
  },
  // 猪瘟净化服务结果
  {
    path: '/rabidresult',
    name: 'rabidresult',
    component: () => import('@/views/rabid/rabidresult.vue')
  },
  // 蓝耳病净化服务
  {
    path: '/blueear',
    name: 'blueear',
    component: () => import('@/views/blueear/index.vue')
  },
  // 蓝耳病净化服务结果
  {
    path: '/blueearresult',
    name: 'blueearresult',
    component: () => import('@/views/blueear/blueearresult.vue')
  },
  // 兽医头条
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/news/index.vue')
  },
  // 邀请好友 中科基因币
  {
    path: '/shareregister',
    name: 'shareregister',
    component: () => import('@/views/shareregister/index.vue')
  },
  // 邀请好友 注册
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/shareregister/register.vue')
  },
  // 注册引导页
  {
    path: '/guide',
    name: 'guide',
    component: () => import('@/views/shareregister/guide.vue')
  },
  // 专家详情
  {
    path: '/guidenew',
    name: 'guidenew',
    component: () => import('@/views/shareregister/guidenew.vue')
  },
  // 邀请好友 中科基因币 成功
  {
    path: '/registersuccess',
    name: 'registersuccess',
    component: () => import('@/views/shareregister/success.vue')
  },
  // 中科基因公司介绍
  {
    path: '/companyInfo',
    name: 'companyInfo',
    component: () => import('@/views/companyInfo.vue')
  },
  // 中科基因公司介绍
  {
    path: '/chathistory',
    name: 'chathistory',
    component: () => import('@/views/chathistory.vue')
  },
  // 打开APP
  {
    path: '/openapp',
    name: 'OpenApp',
    component: () => import('@/views/openapp.vue')
  },
  // 知识宝库
  {
    path: '/information',
    name: 'information',
    component: () => import('@/views/information/information_list.vue')
  },
 //群体生产指标
  {
    path: '/health_group',
    name: 'health_group',
    component: () => import('@/views/information/health_group.vue')
  },
  //畜舍环境指标
  {
    path: '/health_ambient',
    name: 'health_ambient',
    component: () => import('@/views/information/health_ambient.vue')
  },
  //个体生理指标
  {
    path: '/health_thing',
    name: 'health_thing',
    component: () => import('@/views/information/health_thing.vue')
  },
  //风险预警测评
  {
    path: '/health_risk',
    name: 'health_risk',
    component: () => import('@/views/information/health_risk.vue')
  },
  //饲养标准
  {
    path: '/health_rear',
    name: 'health_rear',
    component: () => import('@/views/information/health_rear.vue')
  },
  // 采样一般原则
  {
    path: '/sampling_principle',
    name: 'samplingPrinciple',
    component: () => import('@/views/information/sampling_principle.vue')
  },
  // 采血
  {
    path: '/blood_collection',
    name: 'bloodCollection',
    component: () => import('@/views/information/blood_collection.vue')
  },
  // 全血/血清制备
  {
    path: '/preparation',
    name: 'Preparation',
    component: () => import('@/views/information/preparation.vue')
  },
  // 样本采集
  {
    path: '/specimen_collection',
    name: 'specimenCollection',
    component: () => import('@/views/information/specimen_collection.vue')
  },
  // 猪病化验常识
  {
    path: '/laboratory_knowledge',
    name: 'laboratoryKnowledge',
    component: () => import('@/views/information/laboratory_knowledge.vue')
  },
  // 群体常识
  {
    path: '/general_knowledge',
    name: 'generalKnowledge',
    component: () => import('@/views/information/general_knowledge.vue')
  },
  // 个体常识
  {
    path: '/individual_knowledge',
    name: 'individualKnowledge',
    component: () => import('@/views/information/individual_knowledge.vue')
  },
  // 猪场常用药
  {
    path: '/pigfarm',
    name: 'pigfarm',
    component: () => import('@/views/knowledge/pigfarm.vue')
  },
  // 兽药剂型
  {
    path: '/drugdosage',
    name: 'drugdosage',
    component: () => import('@/views/knowledge/drugdosage.vue')
  },
  // 给药方式
  {
    path: '/getdrugmethod',
    name: 'getdrugmethod',
    component: () => import('@/views/knowledge/getdrugmethod.vue')
  },
  // 用药注意事项
  {
    path: '/medication',
    name: 'medication',
    component: () => import('@/views/knowledge/medication.vue')
  },
  // 兽药储存
  {
    path: '/drugstorage',
    name: 'drugstorage',
    component: () => import('@/views/knowledge/drugstorage.vue')
  },
  // 加入我们
  {
    path: '/addjoin',
    name: 'Addjoin',
    component: () => import('@/views/joinus/addjoin')
  },
  // 共享服务体系
  {
    path: '/comserver',
    name: 'Comserver',
    component: () => import('@/views/joinus/comserver')
  },
  // 牧场健康管理服务
  {
    path: '/muhealth',
    name: 'Muhealth',
    component: () => import('@/views/joinus/muhealth')
  },
  // 牧场健康管理服务
  {
    path: '/comLetserver',
    name: 'comLetserver',
    component: () => import('@/views/joinus/comLetserver')
  },
  // 牧场健康管理服务
  {
    path: '/jiaoyu',
    name: 'jiaoyu',
    component: () => import('@/views/joinus/jiaoyu')
  },


  // 四川驰阳农业开发有限公司
  {
    path: '/partner-1',
    name: 'partner-1',
    component: () => import('@/views/partner/partner-1.vue')
  },
  // 常州市大宇兽药有限公司
  {
    path: '/partner-2',
    name: 'partner-2',
    component: () => import('@/views/partner/partner-2.vue')
  },
  // 江苏京海禽业集团有限公司
  {
    path: '/partner-3',
    name: 'partner-3',
    component: () => import('@/views/partner/partner-3.vue')
  },
  // 四川省康牧动保科技有限公司
  {
    path: '/partner-4',
    name: 'partner-4',
    component: () => import('@/views/partner/partner-4.vue')
  },
  // 四川柯牧生物科技有限公司
  {
    path: '/partner-5',
    name: 'partner-5',
    component: () => import('@/views/partner/partner-5.vue')
  },
  // 山东大北农农牧科技有限责任公司
  {
    path: '/partner-6',
    name: 'partner-6',
    component: () => import('@/views/partner/partner-6.vue')
  },
  // 正大集团山东区
  {
    path: '/partner-7',
    name: 'partner-7',
    component: () => import('@/views/partner/partner-7.vue')
  },
  // 黑龙江大庄园肉业有限公司
  {
    path: '/partner-8',
    name: 'partner-8',
    component: () => import('@/views/partner/partner-8.vue')
  },
  // 哈尔滨华隆蓝狐育种有限公司
  {
    path: '/partner-9',
    name: 'partner-9',
    component: () => import('@/views/partner/partner-9.vue')
  },
  // 哈尔滨市天缘动物保健品经销处
  {
    path: '/partner-10',
    name: 'partner-10',
    component: () => import('@/views/partner/partner-10.vue')
  },
  // 现代牧业（集团）有限公司
  {
    path: '/partner-11',
    name: 'partner-11',
    component: () => import('@/views/partner/partner-11.vue')
  },
  // 河南华扬农牧有限公司
  {
    path: '/partner-12',
    name: 'partner-12',
    component: () => import('@/views/partner/partner-12.vue')
  },
  // 湖南瑞民博环境工程有限公司
  {
    path: '/partner-13',
    name: 'partner-13',
    component: () => import('@/views/partner/partner-13.vue')
  },
  // 福州闽益动保贸易有限公司
  {
    path: '/partner-14',
    name: 'partner-14',
    component: () => import('@/views/partner/partner-14.vue')
  },
  // 河南民正农牧股份有限公司
  {
    path: '/partner-15',
    name: 'partner-15',
    component: () => import('@/views/partner/partner-15.vue')
  },
  // 河南民正农牧股份有限公司
  {
    path: '/partner-16',
    name: 'partner-16',
    component: () => import('@/views/partner/partner-16.vue')
  },
  // 样品检测委托协议
  {
    path: '/testingtreaty',
    name: 'Testingtreaty',
    component: () => import('@/views/testingtreaty.vue')
  },
  // 报告解读说明
  {
    path: '/reportdescription',
    name: 'Reportdescription',
    component: () => import('@/views/reportdescription.vue')
  },
  // 样品的记录、保存、包装和运送
  {
    path: '/transportpackage',
    name: 'Transportpackage',
    component: () => import('@/views/transportpackage.vue')
  },
  // 兽医课堂 分享
  {
    path: '/veterinaryclass',
    name: 'Veterinaryclass',
    component: () => import('@/views/veterinaryclass.vue')
  },
  // 兽医课堂1 分享
  {
    path: '/veterinaryclass1',
    name: 'Veterinaryclass1',
    component: () => import('@/views/veterinaryclass1.vue')
  },
  // 兽医课堂 分享
  {
    path: '/veterinarypropagate',
    name: 'Veterinarypropagate',
    component: () => import('@/views/veterinarypropagate.vue')
  },
  // 运营活动
  {
    path: '/activities',
    name: 'activities',
    component: () => import('@/views/activities.vue')
  },
  // 专家招募
  {
    path: '/expertrecruitment',
    name: 'Expertrecruitment',
    component: () => import('@/views/expertrecruitment.vue')
  },
  // 专家招募
  {
    path: '/expertrecruitment1',
    name: 'Expertrecruitment1',
    component: () => import('@/views/expertrecruitment1.vue')
  },
  // 专家注册
  {
    path: '/identification',
    name: 'identification',
    component: () => import('@/views/identification.vue')
  },
  //专家认证
  {
    path: '/certification',
    name: 'Certification',
    component: () => import('@/views/certification.vue')
  },
  // 专家注册
  {
    path: '/expertregister',
    name: 'expertregister',
    component: () => import('@/views/expertregister.vue')
  },
  // 专家登陆
  {
    path: '/expertlogin',
    name: 'expertlogin',
    component: () => import('@/views/expertlogin.vue')
  },
  // 专家注册协议
  {
    path: '/authentication',
    name: 'authentication',
    component: () => import('@/views/authentication.vue')
  },
  // 专家注册成功
  {
    path: '/expertregistersuccess',
    name: 'expertregistersuccess',
    component: () => import('@/views/expertregistersuccess.vue')
  },
  // 中科名兽医宣传页
  {
    path: '/propaganda',
    name: 'propaganda',
    component: () => import('@/views/propaganda.vue')
  },
  // 中科名兽医宣传页 好兽药链接地址
  {
    path: '/propagandahsy',
    name: 'propagandahsy',
    component: () => import('@/views/propagandahsy.vue')
  },
  // 今日猪价
  {
    path: '/nongzhengtong',
    name: 'nongzhengtong',
    component: () => import('@/views/nongzhengtong/index.vue')
  },
  // 今日猪价
  {
    path: '/pigPrice',
    name: 'pigPrice',
    component: () => import('@/views/pigPrice/index.vue')
  },
  {
    path: '/searchPage',
    name: 'searchPage',
    component: () => import('@/components/searchPage.vue')
  },
  // 中科名兽医WAP端首页
  {
    path: '/wapOfficial',
    name: 'wapOfficial',
    component: () => import('@/views/zkjyOfficial/wap_index.vue')
  },
  // 话题详情页
  {
    path: '/talkdetails',
    name: 'talkdetails',
    component: () => import('@/views/talkdetails.vue')
  },
  // 禽智养殖用户协议
  {
    path: '/qzglannouncement',
    name: 'qzglannouncement',
    component: () => import('@/views/qzglannouncement.vue')
  },
  // 药品详情
  {
    path: '/shopdetail',
    name: 'shopDetail',
    component: () => import('@/views/shopdetail.vue')
  },
  // 手写板
  {
    path: '/handwritten',
    name: 'Handwritten',
    component: () => import('@/views/handwritten.vue')
  },
  // 禽智养殖隐私协议
  {
    path: '/qzglprivacypolicy',
    name: 'qzglprivacypolicy',
    component: () => import('@/views/qzglprivacypolicy.vue')
  },
  // 确认课程
  {
    path: '/confirmcourse',
    name: 'confirmcourse',
    component: () => import('@/views/confirmcourse.vue')
  },
  // 天买邀请页
  {
    path: '/settled',
    name: 'Settled',
    component: () => import('@/views/settled.vue')
  },
  // 朋友圈页面
  {
    path: '/sharePage',
    name: 'SharePage',
    component: () => import('@/views/share.vue')
  },
  // 天买协议
  {
    path: '/tianmaiAgreement',
    name: 'TianmaiAgreement',
    component: () => import('@/views/tianmai/tianmaiAgreement.vue')
  },
  // 天买购买须知
  {
    path: '/tianmaiPurchase',
    name: 'TianmaiPurchase',
    component: () => import('@/views/tianmai/tianmaiPurchase.vue')
  },
  // 禽智养殖
  {
    path: '/shedDisplay',
    name: 'ShedDisplay',
    component: () => import('@/views/qzyz/shedDisplay.vue')
  },
  {
    path: '/inspectionRecord',
    name: 'InspectionRecord',
    component: () => import('@/views/qzyz/inspectionRecord.vue')
  },
  {
    path: '/worklog',
    name: 'Worklog',
    component: () => import('@/views/qzyz/worklog.vue')
  },
  {
    path:"/invoice",
    name:'Invoice',
    component: ()=> import('@/views/invoice.vue')
  }
  //


  // {
  //   path: '/joinus',
  //   name:'Joinus',
  //   children: [
  //     {
  //       path: 'comserver',
  //       name: 'Comserver',
  //       component: () => import('@/views/joinus/comserver'),
  //     },
  //   ]

  // },
]

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export default router
